import React from 'react';
import { connect } from 'react-redux';
import { getContentLaunchUrl } from '../../services/api/classroomApi';

class LaunchRedirect extends React.Component {
  componentDidMount() {
    const { sectionId, activityId, lis_outcome_service_url, lis_result_sourcedid } = this.props.location.query;
    const { email } = this.props;
    const language = this.props.language.toUpperCase();
    const lis_outcome_service_url_parsed = lis_outcome_service_url ? new URL(lis_outcome_service_url) : undefined;
    if (lis_outcome_service_url) {
      lis_outcome_service_url_parsed.searchParams.set('studentEmail', email);
    }

    getContentLaunchUrl(
      sectionId,
      activityId,
      language,
      lis_outcome_service_url_parsed.toString(),
      lis_result_sourcedid
    ).then(res => {
      window.location.href = res.data.url;
    });
  }

  render() {
    return <></>;
  }
}

function mapStateToProps(state) {
  return {
    location: state.router.location,
    language: state.account.user.language,
    email: state.account.user.email
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(LaunchRedirect);
